import { isElementWithTagName } from './node';

export function isInlineCodeElement(node: Node | null): node is HTMLElement {
  return isElementWithTagName(node, 'code');
}
